import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import RealEstateAgentManagementList from './components/RealEstateAgentManagementList';

const { Cell } = ResponsiveGrid;

const RealEstateAgentManagement = ({ showHeader = true }) => (
  <ResponsiveGrid gap={20}>
    {showHeader && (
      <Cell colSpan={12}>
        <PageHeader
          title="房仲預約及登記"
          // description="房仲列表"
          breadcrumbs={[
            {
              name: '房仲管理',
            },
            {
              name: '房仲預約及登記',
            },
          ]}
        />
      </Cell>
    )}

    <Cell colSpan={12}>
      <RealEstateAgentManagementList />
    </Cell>
  </ResponsiveGrid>
);

export default RealEstateAgentManagement;
